module.exports = __webpack_public_path__ + "static/media/Leccion-10.29-Compartiendo-de-Cristo-a-mi-Familia.8c3ded99.pdf";